import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import moment from "moment";
import md5 from "md5";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
// Redux
import { useSelector } from "react-redux";
// Constants - Functions
import { WEB_SERVICE_MIMS, pathHomePage, applications, pathologies } from "../../config/constants";
import { passwordValidation, dateValidation, parsedDate, HeightValidation } from "../../config/functions";
// Components
import Axios from "../../config/axios";
import { Form } from "./styles";
import Title from "../title";
import PersonalInformation from "./sections/personalInformation";
import Terms from "./sections/terms";
import Footer from "./sections/footer";

const AddPatient = () => {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [gender, setGender] = useState("");
  const [height, setHeight] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [gameExperience, setGameExperience] = useState("");
  const [computerExperience, setComputerExperience] = useState("");
  const [otherInfo, setOtherInfo] = useState("");
  const [pathology] = useState(pathologies.amputationId);
  const [pareticSide, setPareticSide] = useState("");
  const [terms, setTerms] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [appsArray] = useState([applications.clinicId]);
  // handle errors
  const [loginError, setLoginError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [genderError, setGenderError] = useState(false);
  const [heightError, setHeightError] = useState(false);
  const [dateOfBirthError, setDateOfBirthError] = useState(false);
  const [pareticSideError, setPareticSideError] = useState(false);
  const [termsError, setTermsError] = useState(false);

  const [t] = useTranslation("global");
  const clinicianData = useSelector(({ clinician }) => clinician.data);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!login || !gender || !height || !pathology || !dateOfBirth || !pareticSide) {
      if (!login) setLoginError(true);
      if (!passwordValidation(password)) setPasswordError(true);
      if (!gender) setGenderError(true);
      if (!height) setHeightError(true);
      if (!dateOfBirth) setDateOfBirthError(true);
      if (!pareticSide) setPareticSideError(true);
      return toast.error(t("profileMessage.emptyFieldsMessage"));
    }

    if (login.length > 10) {
      setLoginError(true);
      return toast.error(t("profileMessage.usernameMessage"));
    }

    if (!passwordValidation(password)) {
      setPasswordError(true);
      return toast.error(t("profileMessage.passwordMessage"));
    }

    if (!HeightValidation(height)) {
      setHeightError(true);
      return toast.error(t("profileMessage.heightMessage"));
    }

    if (!dateValidation(dateOfBirth)) {
      toast.error(t("profileMessage.birthDateMessage"));
      return setDateOfBirthError(true);
    }

    if (!terms) {
      toast.error(t("addPatient.conditionsMessage"));
      return setTermsError(true);
    }

    const data = {
      HOSPITAL_ID: clinicianData.HOSPITAL_ID,
      PATIENT_USER: login,
      PASSWORD: md5(`${login}${password}`),
      PARETIC_SIDE: pareticSide,
      GENDER: gender,
      BIRTH_DATE: moment(parsedDate(dateOfBirth)).format("YYYY/MM/DD"),
      VIDEOGAME_EXP: gameExperience === "" ? null : Number(gameExperience),
      COMPUTER_EXP: computerExperience === "" ? null : Number(computerExperience),
      COMMENTS: otherInfo === "" ? null : otherInfo,
      PTN_HEIGHT_CM: Number(height),
      AFFECTATION_ID: Number(pathology),
      STROKE_DATE: new Date(),
      PATIENT_SOFTWARE: appsArray,
    };

    Axios("post", `${WEB_SERVICE_MIMS}/patients/add`, data)
      .then(({ data }) => {
        if (data.patientAdded) {
          toast.success(t("addPatient.patientAddedMessage"));
          setRedirect(true);
        }
        if (data.duplicatedPatient) {
          setLoginError(true);
          toast.error(t("profileMessage.duplicatedUserMessage"));
        }
      })
      .catch((error) => {
        toast.error(t("profileMessage.sendDataMessage"));
        console.log("endpoint to add patient", error);
      });
  };
  if (redirect) {
    return <Redirect to={`${pathHomePage}/home/${clinicianData.token}`} />;
  }

  return (
    <>
      <Title title={t("addPatient.title")} marginBottom="10px" />
      <Form onSubmit={handleSubmit}>
        <PersonalInformation
          login={login}
          setLogin={setLogin}
          loginError={loginError}
          setLoginError={setLoginError}
          password={password}
          setPassword={setPassword}
          passwordError={passwordError}
          setPasswordError={setPasswordError}
          gender={gender}
          setGender={setGender}
          genderError={genderError}
          setGenderError={setGenderError}
          height={height}
          setHeight={setHeight}
          heightError={heightError}
          setHeightError={setHeightError}
          dateOfBirth={dateOfBirth}
          setDateOfBirth={setDateOfBirth}
          dateOfBirthError={dateOfBirthError}
          setDateOfBirthError={setDateOfBirthError}
          gameExperience={gameExperience}
          setGameExperience={setGameExperience}
          computerExperience={computerExperience}
          setComputerExperience={setComputerExperience}
          otherInfo={otherInfo}
          setOtherInfo={setOtherInfo}
          pareticSide={pareticSide}
          setPareticSide={setPareticSide}
          pareticSideError={pareticSideError}
          setPareticSideError={setPareticSideError}
        />
        <Terms terms={terms} setTerms={setTerms} termsError={termsError} setTermsError={setTermsError} />
        <Footer handleSubmit={handleSubmit} />
      </Form>
    </>
  );
};

export default AddPatient;
